import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NotaryCalculatorComponent} from './notary-calculator/notary-calculator.component';
import {HowToSellComponent} from './how-to-sell/how-to-sell.component';
import {AboutRegionAndCountryComponent} from './about-region-and-country/about-region-and-country.component';
import {BrowserModule} from '@angular/platform-browser';
import {TranslateModule} from '../../shared/pipes/translate/translate.module';
import {PolicyComponent} from './policy/policy.component';

@NgModule({
  declarations: [
    NotaryCalculatorComponent,
    HowToSellComponent,
    AboutRegionAndCountryComponent,
    PolicyComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    TranslateModule
  ],
  exports: [
    NotaryCalculatorComponent,
    HowToSellComponent,
    AboutRegionAndCountryComponent,
    PolicyComponent],
})
export class HelpfulModule {
}
